import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <Path
        d="M8 16.8a1.465 1.465 0 011.467-1.467h.627a6.592 6.592 0 00-.26 1.834c0 .368.031.736.095 1.1h-.462A1.467 1.467 0 018 16.8zm16.867 1.467V16.8a1.467 1.467 0 00-1.467-1.467h-.627a6.59 6.59 0 01.26 1.834c0 .368-.032.736-.095 1.1h1.929zm-4.936 0a3.667 3.667 0 10-6.996 0h4.199a.55.55 0 00-.517-.733h-.367a1.28 1.28 0 01-.183-2.549V14.6a.367.367 0 01.733 0v.367h.733a.366.366 0 110 .733H16.25a.55.55 0 100 1.1h.367a1.285 1.285 0 011.268 1.467h2.046zm-7.758 0a4.4 4.4 0 118.521 0h1.5a5.867 5.867 0 10-11.52 0h1.499zM21.2 24.5a2.202 2.202 0 012.2-2.2h2.933v-1.467A1.834 1.834 0 0024.5 19H9.467A2.175 2.175 0 018 18.435v9.732A1.834 1.834 0 009.833 30H24.5a1.834 1.834 0 001.833-1.833V26.7H23.4a2.202 2.202 0 01-2.2-2.2zm5.5-1.467h-3.3a1.467 1.467 0 000 2.934h3.3a.367.367 0 00.367-.367v-2.2a.367.367 0 00-.367-.367zm3.265-11.523a.366.366 0 00-.332-.21h-1.466V8.367A.367.367 0 0027.8 8h-2.933a.367.367 0 00-.367.367V11.3h-1.467a.367.367 0 00-.284.599l3.3 4.033a.368.368 0 00.568 0l3.3-4.033a.366.366 0 00.048-.39z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
